/**
 * The AIR Suit card's colour switch — spec 15. Everything it needs is already on the chip, so a
 * colour change touches no network at all.
 */
if (!customElements.get('suit-card')) {
  customElements.define(
    'suit-card',
    class SuitCard extends HTMLElement {
      connectedCallback() {
        this.chips = [...this.querySelectorAll('li[data-blazer-id]')];
        this.addEventListener('click', (event) => {
          const chip = event.target.closest('li[data-blazer-id]');
          if (!chip) return;
          // The chip is a real link to the colour, so the card still works with no JS. Here it must
          // not navigate — spec 15 is a swap in place.
          event.preventDefault();
          this.select(chip);
        });
        if (this.chips.length) this.select(this.querySelector('li.is-selected') || this.chips[0]);
      }

      select(chip) {
        const { colour, image, price, compare, url } = chip.dataset;

        this.chips.forEach((li) => li.classList.toggle('is-selected', li === chip));

        const img = this.querySelector('[data-suit-image]');
        // The old file stays on screen until the new one is decoded, so the card never blinks empty.
        // `wanted` settles a fast click-through: two decodes can finish out of order, and without it
        // the slower one wins and the card ends up showing a colour nobody has selected.
        if (img && img.getAttribute('src') !== image) {
          this.wanted = image;
          const next = new Image();
          next.src = image;
          const show = () => {
            if (this.wanted === image) img.setAttribute('src', image);
          };
          next.decode().then(show, show);
        }

        this.querySelector('[data-suit-colour]').textContent = colour;
        this.querySelectorAll('[data-suit-link]').forEach((a) => a.setAttribute('href', url));

        // The theme reads the sale state off `f-price--on-sale`, which hides whichever of the two
        // rows does not apply — so only that class and the three strings have to move.
        const onSale = compare !== '';
        this.querySelector('[data-suit-price]').classList.toggle('f-price--on-sale', onSale);
        this.querySelector('[data-suit-regular]').textContent = price;
        this.querySelector('[data-suit-sale]').textContent = price;
        this.querySelector('[data-suit-compare]').textContent = compare;
        this.querySelector('[data-suit-badge]').hidden = !onSale;
      }
    }
  );
}
